import React, { use, useEffect, useState } from "react";
import styles from "./AccountSettings.module.css";
import { Modal, SubmitButton, TextComponent } from "../../../components";
import editUser from "../../../assets/images/editUser.png";
import keyIcon from "../../../assets/images/twoStepIcon.png";
import Switch from "../../../components/Switch/Switch";
import { RxLockClosed } from "react-icons/rx";
import { FiArrowRightCircle } from "react-icons/fi";
import { RiLogoutCircleRLine, RiNotification4Line } from "react-icons/ri";
import { PiSealCheck, PiUserCircleMinus } from "react-icons/pi";
import EditProfile from "./EditProfile/EditProfile";
import ChangePassword from "./ChangePassword/ChangePassword";
import { BsExclamationTriangle } from "react-icons/bs";
import DeleteAccount from "./DeleteAccount/DeleteAccount";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { useNavigate } from "react-router-dom";
import { getUser, isLogin } from "../../../Store/Actions/AuthAction";
import { sessionExpired } from "../../../Store/Actions/GeneralActions";
import dummyImg from "../../../assets/images/dummy.png";
import { phoneFormat } from "../../../utills";
const AccountSettings = () => {
  const [editProfileModal, setEditProfileModal] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [deleteAccountModal, setDeleteAccountModal] = useState(false);
  const [confirmDeleteAccount, setConfirmDeleteAccount] = useState(false);
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [details, setDetails] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer.user);

  const [isSwitchOn, setIsSwitchOn] = useState();
  const ToggleEmailNotifications = () => {
    let data = {
      email_notifications: user?.email_notifications == 1 ? 0 : 1,
      is_2fa_enabled: user?.is_2fa_enabled,
    };
    dispatch(AuthMiddleware.EmailNotification(data));
  };

  const ToggleTwoStep = () => {
    let data = {
      email_notifications: user?.email_notifications,
      is_2fa_enabled: user?.is_2fa_enabled == 1 ? 0 : 1,
    };
    dispatch(AuthMiddleware.EmailNotification(data));
  };

  const onPressDeleteAccount = () => {
    dispatch(AuthMiddleware.delAcc()).then((data) => {
      setIsSuccessFulModal(true);
      dispatch(getUser(null));
      dispatch(isLogin(false));
      dispatch(sessionExpired(false));
      localStorage.clear();
      navigate("/");
    });
  };

  useEffect(() => {
    dispatch(AuthMiddleware.getUserData());
  }, []);

  const onLogout = () => {
    dispatch(AuthMiddleware.logout()).then((data) => {
      setDeleteAccountModal(false);
      dispatch(getUser(null));
      dispatch(isLogin(false));
      dispatch(sessionExpired(false));
      localStorage.clear();
      navigate("/");
    });
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.twoCont}>
        <div className={styles.leftCont}>
          <div className={styles.leftCont_upper}>
            {/* <div> */}
            <img
              className={styles.profileImg}
              src={user?.profile_picture ? user?.profile_picture : dummyImg}
              alt="dummyImg"
            />
            {/* </div> */}
            <TextComponent
              text={user?.full_name || "--"}
              style={{
                fontFamily: "Urbanist-bold",
                fontSize: "var(--dashboard_tabs-font-size)",
              }}
            />
            <TextComponent
              text={phoneFormat(user?.contact_no) || "--"}
              className={styles.leftCont_text}
            />
            <TextComponent
              text={user?.email || "--"}
              className={styles.leftCont_text}
            />
            <TextComponent
              text={user.address || "--"}
              className={styles.leftCont_text}
            />
            <SubmitButton
              onClick={() => {
                setEditProfileModal(true);
                setDetails();
              }}
              btnClass={styles.leftCont_button}
              title={"Edit Profile"}
              secondaryBtn
              leftIcon={<img src={editUser} className={styles.editUser} />}
            />
          </div>
          <div className={styles.leftCont_bottom}>
            <div className={styles.leftCont_subBottom}>
              <div className={styles.leftSubBottom_left}>
                <img src={keyIcon} />
                <TextComponent
                  text={"Two step verification"}
                  style={{ fontFamily: "Urbanist-bold" }}
                />
              </div>
              <div className={styles.leftSubBottom_right}>
                <Switch
                  isChecked={user?.is_2fa_enabled == 1 ? true : false}
                  activeColor={"var(--secondary-color)"}
                  inactiveColor={"var(--light-grey)"}
                  onChange={ToggleTwoStep}
                  size="small"
                />
              </div>
            </div>
            <div
              className={styles.leftCont_subBottom}
              onClick={() => setChangePasswordModal(true)}
            >
              <div className={styles.leftSubBottom_left}>
                <RxLockClosed
                  color="var(--light-grey)"
                  size={"25px"}
                  style={{ marginRight: "10px" }}
                />
                <TextComponent
                  text={"Change Password"}
                  style={{ fontFamily: "Urbanist-bold" }}
                />
              </div>
              <div className={styles.leftSubBottom_right}>
                <FiArrowRightCircle
                  color="var(--secondary-color)"
                  size={"25px"}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rightCont}>
          <div className={styles.rightCont_header}>
            <RiNotification4Line
              color={"var(--light-grey)"}
              size={"25px"}
              style={{ marginRight: "10px" }}
            />
            <TextComponent
              text={"Notification Settings"}
              style={{
                fontFamily: "Urbanist-bold",
                fontSize: "var(--dashboard_tabs-font-size)",
              }}
            />
          </div>
          <div className={styles.rightCont_content}>
            {/* <div className={styles.rightCont_subcontent}>
              <TextComponent
                text={"In app notification"}
                style={{ fontFamily: "Urbanist-bold" }}
              />
              <Switch
                value={isVerificationOn}
                activeColor={"var(--secondary-color)"}
                inactiveColor={"var(--light-grey)"}
                onChange={() => setIsVerificationOn(!isVerificationOn)}
                size="small"
              />
            </div>
            <div className={styles.rightCont_subcontent}>
              <TextComponent
                text={"high priority notifications"}
                style={{ fontFamily: "Urbanist-bold" }}
              />
              <Switch
                value={isVerificationOn}
                activeColor={"var(--secondary-color)"}
                inactiveColor={"var(--light-grey)"}
                onChange={() => setIsVerificationOn(!isVerificationOn)}
                size="small"
              />
            </div>
            <div className={styles.rightCont_subcontent}>
              <TextComponent
                text={"Non critical notifications"}
                style={{ fontFamily: "Urbanist-bold" }}
              />
              <Switch
                value={isVerificationOn}
                activeColor={"var(--secondary-color)"}
                inactiveColor={"var(--light-grey)"}
                onChange={() => setIsVerificationOn(!isVerificationOn)}
                size="small"
              />
            </div> */}
            <div
              className={styles.rightCont_subcontent}
              style={{ borderBottom: "none" }}
            >
              <TextComponent
                text={"Email notifications"}
                style={{ fontFamily: "Urbanist-bold" }}
              />
              <Switch
                isChecked={user?.email_notifications == 1 ? true : false}
                activeColor={"var(--secondary-color)"}
                inactiveColor={"var(--light-grey)"}
                onChange={ToggleEmailNotifications}
                size="small"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className={styles.logoutBtn}
        onClick={
          onLogout
          //   () => {
          //   dispatch(AuthMiddleware.logout()).then((data) => {
          //     navigate("/");
          //   });
          // }
        }
      >
        <RiLogoutCircleRLine size={20} style={{ marginRight: "10px" }} />
        <TextComponent
          text={"Logout"}
          style={{ fontFamily: "Urbanist-semibold" }}
        />
      </div>
      <div
        className={styles.logoutBtn}
        onClick={() => setDeleteAccountModal(true)}
      >
        <PiUserCircleMinus
          size={20}
          color="var(--light-grey)"
          style={{ marginRight: "10px" }}
        />
        <TextComponent
          text={"Delete Account"}
          style={{
            fontFamily: "Urbanist-semibold",
            color: "var(--light-grey)",
          }}
        />
      </div>
      <EditProfile
        editProfileModal={editProfileModal}
        setEditProfileModal={setEditProfileModal}
        details={details}
        setDetails={setDetails}
        ProfileDetails={user}
      />
      <ChangePassword
        changePasswordModal={changePasswordModal}
        setChangePasswordModal={setChangePasswordModal}
      />
      <Modal
        open={deleteAccountModal}
        onCancel={() => setDeleteAccountModal(false)}
        icon={
          <BsExclamationTriangle
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            color="var(--primary-color)"
          />
        }
        title={"You want to delete your account?"}
        width={"400px"}
        twoButton
        okBtnTitle={"No, go back"}
        cancelBtnTitle={"Yes, Delete"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={onPressDeleteAccount}
        onClickOkButton={() => {
          setDeleteAccountModal(false);
        }}
        btnStyle={{ width: "80%" }}
      ></Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Your account has been deleted"}
        width={"400px"}
      ></Modal>
      {/* <DeleteAccount
        confirmDeleteAccount={confirmDeleteAccount}
        setConfirmDeleteAccount={setConfirmDeleteAccount}
      /> */}
    </div>
  );
};

export default AccountSettings;
